import { createFeatureSelector } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';

import { IPataProjectsState, PataProjectFeatureKey, PataProjectsInitialState } from './project/project.state';
import { IPataPhasesState, PataPhaseFeatureKey, PataPhasesInitialState } from './planning/phase.state';
import { IPataDocumentsState, PataDocumentFeatureKey, PataDocumentsInitialState } from './document/document.state';
import { IPataCopilsState, PataCopilFeatureKey, PataCopilsInitialState } from './copils/copils.state';
import { IPataCopilDocumentsState, PataCopilDocumentFeatureKey, PataCopilDocumentsInitialState } from './copils/copil-document/copil-document.state';
import { IPataSharedDocumentsState, PataSharedDocumentFeatureKey, PataSharedDocumentsInitialState } from './shared-documents/shared-documents.state';

export const PataFeatureKey = 'pata';

export interface IState extends IAuroraState
{
    [PataFeatureKey]: IPataState;
}

export interface IPataState
{
    [PataProjectFeatureKey]: IPataProjectsState;
    [PataPhaseFeatureKey]: IPataPhasesState;
    [PataDocumentFeatureKey]: IPataDocumentsState;
    [PataCopilFeatureKey]: IPataCopilsState;
    [PataCopilDocumentFeatureKey]: IPataCopilDocumentsState;
    [PataSharedDocumentFeatureKey]: IPataSharedDocumentsState;
}

export const PataInitialState: IPataState = {
    [PataProjectFeatureKey]: PataProjectsInitialState,
    [PataPhaseFeatureKey]: PataPhasesInitialState,
    [PataDocumentFeatureKey]: PataDocumentsInitialState,
    [PataCopilFeatureKey]: PataCopilsInitialState,
    [PataCopilDocumentFeatureKey]: PataCopilDocumentsInitialState,
    [PataSharedDocumentFeatureKey]: PataSharedDocumentsInitialState
};

export const getPataState = createFeatureSelector<IPataState>(
    PataFeatureKey
);
